import {CONDITION_TYPE} from './condition.type.model';
import {OPERATOR_COMPARAISON} from './operator.comparaison.model';

export interface Condition {
    type: CONDITION_TYPE;
    values: string[];

    // ConditionMetadata :
    metadataId?: number;

    // ConditionAnswer :
    pageId?: number;
    questionId?: number;
    subQuestionId?: number;
    operator?: OPERATOR_COMPARAISON;
}

/**
 * Condition à remplir, telle qu'elle s'ouvre : vide de tout, sauf de ce sur quoi elle portera.
 *
 * La réponse par défaut, parce que c'est de loin le cas courant — on conditionne d'abord un élément
 * à ce que le répondant vient de dire. Devant la première question de l'enquête, où aucune réponse
 * n'a encore été donnée, l'appelant demande une condition sur métadonnée.
 */
export const buildEmptyCondition = (type: CONDITION_TYPE = CONDITION_TYPE.ANSWER): Condition => ({type, values: []});
